export const CONFIG = {
  authUrl: 'https://sports-authority.bypassmobile.com',
  cloverSportDomain: 'bypassmobile.com',
  cookiePrefix: 'prod',
  flippyEndpoint: 'https://feature-flip.bypassmobile.com',
  managerUrl: 'https://manager.bypassmobile.com',
  showMarcus: false,
  sentryDsn: 'https://d7b3cc077126b3e36cfddaf110c611a8@o30763.ingest.us.sentry.io/4509039033778176'
};
